module.exports = __webpack_public_path__ + "static/media/stonks_green.68dfa160.svg";